import { render, staticRenderFns } from "./PurScI.vue?vue&type=template&id=2a6112ea"
import script from "./PurScI.vue?vue&type=script&lang=js"
export * from "./PurScI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports